// extracted by mini-css-extract-plugin
export default {"pageContent":"pageContent__3Oa6i"};